// extracted by mini-css-extract-plugin
export default {"searchBlock":"Search_searchBlock__P1H2M","searchInput":"Search_searchInput__JV0cW"};